import { useEffect, useRef, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const IDLE_TIMEOUT = 15 * 60 * 1000; // 15 minutes

export function useAutoLogout() {
  const { handleLogout } = useContext(AuthContext);
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      handleLogout();
      // alert("Logged out due to inactivity (15 minutes)");
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    resetTimer(); // start timer

    const events = ["mousemove", "keydown", "scroll", "click"];

    events.forEach((e) => window.addEventListener(e, resetTimer));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((e) =>
        window.removeEventListener(e, resetTimer)
      );
    };
    // eslint-disable-next-line
  }, [handleLogout]);
}
